export default __webpack_public_path__ + "static/media/pc_step_2_Cn.ae58a229.png";